import { v4 as uuidv4 } from "uuid";

/**
 * Logs assessment operations for debugging
 */
export const logAssessmentOperation = (operation: string, data: any) => {
  const logEntry = {
    timestamp: new Date().toISOString(),
    operation,
    sessionId: sessionStorage.getItem('assessment_session_id') || 'unknown',
    userAgent: navigator.userAgent.substring(0, 100),
    ...data
  };
  
  console.log(`[ASSESSMENT ${operation}]`, logEntry);
  
  // Store in localStorage for debugging and monitoring
  try {
    const logs = JSON.parse(localStorage.getItem('assessment_operation_logs') || '[]');
    logs.push(logEntry);
    
    // Keep only last 100 logs
    if (logs.length > 100) {
      logs.splice(0, logs.length - 100);
    }
    
    localStorage.setItem('assessment_operation_logs', JSON.stringify(logs));
  } catch (error) {
    console.warn("Failed to store operation log:", error);
  }
};

// Initialize session ID for monitoring
if (!sessionStorage.getItem('assessment_session_id')) {
  sessionStorage.setItem('assessment_session_id', uuidv4());
}
